// src/pages/Contact.js
import React from 'react';
import './Cartas.css';

const Cartas = () => {
  return (
    <div>
    <div className='Espacio-titulo'>      
    </div>

    <div className='containercartas'>

      <div className='subcontainercartas'>
        <h1>Cartas de navegación</h1>
        <table className='tabla-cartas'>
          <tr>
            <div className='divisorcartas1'></div>
          </tr>
          <tr>
            <th><a href="/cartasnav/MVA.pdf" target="_blank" rel="noreferrer">MVA CLO</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/AMA.pdf" target="_blank" rel="noreferrer">AMA CLO</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/TMA.pdf" target="_blank" rel="noreferrer">TMA CLO</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/CTA.pdf" target="_blank" rel="noreferrer">CTA CLO</a></th>
          </tr>          
          <tr>
            <th><a href="/cartasnav/VFR SKCL.pdf" target="_blank" rel="noreferrer">VFR CLO</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR SKPP.pdf" target="_blank" rel="noreferrer">VFR PPN </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR AXM.pdf" target="_blank" rel="noreferrer">VFR AXM </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR CRC.pdf" target="_blank" rel="noreferrer">VFR CRC </a></th>
          </tr> 
          <tr>
            <th><a href="/cartasnav/NIVEL INFERIOR.pdf" target="_blank" rel="noreferrer">Nivel inferior</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/NIVEL SUPERIOR - RNAV 5.pdf" target="_blank" rel="noreferrer">Nivel superior, RNAV 5</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/SKCL JEPPESEN.pdf" target="_blank" rel="noreferrer">SKCL Jeppesen</a></th>
          </tr>
          
          
          
               
          
        </table>
      </div>

      <div className='subcontainercartas'>
        <h1>Cartas de navegación</h1>
        <table className='tabla-cartas'>
          <tr>
            <div className='divisorcartas2'></div>
          </tr>
          <tr>
            <th><a href="/cartasnav/CTA BAQ NORTE.pdf" target="_blank" rel="noreferrer">CTA BAQ NORTE</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/CTA BAQ SUR.pdf" target="_blank" rel="noreferrer">CTA BAQ SUR</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/CTA MDE.pdf" target="_blank" rel="noreferrer">CTA MDE</a></th>
          </tr> 
          <tr>
            <th><a href="/cartasnav/TMA BOG.pdf" target="_blank" rel="noreferrer">TMA, AMA y MVA BOG</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/TMA MDE.pdf" target="_blank" rel="noreferrer">TMA, AMA y MVA MDE</a></th>
          </tr>  
          <tr>
            <th><a href="/cartasnav/TMA ADZ.pdf" target="_blank" rel="noreferrer">TMA y AMA ADZ</a></th>
          </tr>       
          <tr>
            <th><a href="/cartasnav/TMA BAQ.pdf" target="_blank" rel="noreferrer">TMA y AMA BAQ</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/TMA PEI.pdf" target="_blank" rel="noreferrer">TMA y AMA PEI</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/TMA BGA.pdf" target="_blank" rel="noreferrer">TMA y AMA BGA</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/TMA LET.pdf" target="_blank" rel="noreferrer">TMA y AMA LET</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/TMA VVC.pdf" target="_blank" rel="noreferrer">TMA y AMA VVC</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/TMA ANDES.pdf" target="_blank" rel="noreferrer">TMA ANDES</a></th>
          </tr>                    
          <tr>
            <th><a href="/cartasnav/TMA CUC.pdf" target="_blank" rel="noreferrer">TMA CUC</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/TMA EYP.pdf" target="_blank" rel="noreferrer">TMA EYP</a></th>
          </tr>          
          <tr>
            <th><a href="/cartasnav/TMA NVA.pdf" target="_blank" rel="noreferrer">TMA NVA</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/SMA CUC.pdf" target="_blank" rel="noreferrer">SMA CUC</a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/TMA PAL.pdf" target="_blank" rel="noreferrer">TMA PAL</a></th>
          </tr>                   
          
          <tr>
            <th><a href="/cartasnav/TMA TQS.pdf" target="_blank" rel="noreferrer">TMA TQS</a></th>
          </tr>
          
              
           
          
          
        </table>
      </div>

      <div className='subcontainercartas'>
        <h1>Cartas VFR</h1>
        <table className='tabla-cartas'>
          <tr>
            <div className='divisorcartas3'></div>
          </tr>
          
          <tr>
            <th><a href="/cartasnav/VFR BAQ.pdf" target="_blank" rel="noreferrer">VFR BAQ </a></th>
          </tr> 
          <tr>
            <th><a href="/cartasnav/VFR BOG.pdf" target="_blank" rel="noreferrer">VFR BOG </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR BGA.pdf" target="_blank" rel="noreferrer">VFR BGA </a></th>
          </tr> 
          <tr>
            <th><a href="/cartasnav/VFR CTG.pdf" target="_blank" rel="noreferrer">VFR CTG </a></th>
          </tr>           
          <tr>
            <th><a href="/cartasnav/VFR CUC.pdf" target="_blank" rel="noreferrer">VFR CUC </a></th>
          </tr>   
          <tr>
            <th><a href="/cartasnav/VFR CZU.pdf" target="_blank" rel="noreferrer">VFR CZU </a></th>
          </tr> 
          <tr>
            <th><a href="/cartasnav/VFR EYP.pdf" target="_blank" rel="noreferrer">VFR EYP </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR FLA.pdf" target="_blank" rel="noreferrer">VFR FLA </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR GIR.pdf" target="_blank" rel="noreferrer">VFR GIR </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR GYM.pdf" target="_blank" rel="noreferrer">VFR GYM </a></th>
          </tr> 
          <tr>
            <th><a href="/cartasnav/VFR IBE.pdf" target="_blank" rel="noreferrer">VFR IBE </a></th>
          </tr>   
          <tr>
            <th><a href="/cartasnav/VFR LCE.pdf" target="_blank" rel="noreferrer">VFR LCE </a></th>
          </tr> 
          <tr>
            <th><a href="/cartasnav/VFR MDE.pdf" target="_blank" rel="noreferrer">VFR MDE </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR MTR.pdf" target="_blank" rel="noreferrer">VFR MTR </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR MZL.pdf" target="_blank" rel="noreferrer">VFR MZL </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR NVA.pdf" target="_blank" rel="noreferrer">VFR NVA </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR PVA.pdf" target="_blank" rel="noreferrer">VFR PVA </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR RNG.pdf" target="_blank" rel="noreferrer">VFR RNG </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR SMR.pdf" target="_blank" rel="noreferrer">VFR SMR </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR UIB.pdf" target="_blank" rel="noreferrer">VFR UIB </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR VUP.pdf" target="_blank" rel="noreferrer">VFR VUP </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/VFR VVC.pdf" target="_blank" rel="noreferrer">VFR VVC </a></th>
          </tr>
          <tr>
            <th><a href="/cartasnav/KOPTERBOG.pdf" target="_blank" rel="noreferrer">KOPTER BOG </a></th>
          </tr>
          
        </table>
      </div>

    </div>
    </div>
  );
};

export default Cartas;
